import React from 'react';
import './styles.css';

interface PlayBackTimeProps {
  currentTime: number;
  duration: number;
}

const formatTime = (timeInSecond: number): string => {
  return `${String(Math.floor(timeInSecond / 60)).padStart(2, '0')} : ${String(
    Math.floor(timeInSecond % 60),
  ).padStart(2, '0')}`;
};

const PlayBackTime: React.SFC<PlayBackTimeProps> = ({
  currentTime,
  duration,
}) => (
  <div className="audio-player__play-back-time">{formatTime(currentTime)}</div>
);

export default PlayBackTime;
